import React from 'react'
import { api } from '../api/client'
import { connectAvailable } from './connectAvailable'
import { cardNeedsAttention } from './visibility'

const CardNotificationBanner = React.lazy(() => import('./CardNotificationBanner'))

// CardAttentionBanner shows the embedded notification banner at the top of
// Today when Stripe needs her attention (needs_attention, or a restricted
// capability). It renders nothing otherwise, nothing while card payments are
// not configured, and nothing in stub mode (e2e or no publishable key). The
// embedded banner and Connect.js load only when it is shown.
export default function CardAttentionBanner() {
  const [attention, setAttention] = React.useState(false)

  React.useEffect(() => {
    if (!connectAvailable) return
    let live = true
    api
      .cardAccount()
      .then((account) => {
        if (live) setAttention(cardNeedsAttention(account))
      })
      .catch(() => {
        // The banner is a nudge; Today works without it.
      })
    return () => {
      live = false
    }
  }, [])

  if (!attention || !connectAvailable) return null
  return (
    <React.Suspense fallback={null}>
      <CardNotificationBanner />
    </React.Suspense>
  )
}
